import React, { useState, useEffect, Fragment, useRef } from "react"
import ListButton from "./ListButton"
import { useDispatch, useSelector } from "react-redux"
import FilesButton from "./FilesButton"
import Autocomplete from "@material-ui/lab/Autocomplete"
import { makeStyles } from "@material-ui/core/styles"
import ReactTagInput from "@pathofdev/react-tag-input"
import "@pathofdev/react-tag-input/build/index.css"
import Tooltip from "@material-ui/core/Tooltip"
import InfoDialog from "../common/InfoDialog"
import DatePicker from "react-datepicker"
import "react-datepicker/dist/react-datepicker.css"
import { getMonth, getYear } from "date-fns"
import range from "lodash/range"
import { sourceHelper } from "../../helpers/sourceHelper"
import { filter } from "d3"
// Translations
import { useTranslation } from "react-i18next"
import CustomDatePicker from "../common/custom_DatePicker"
import ColorPicker from "../common/ColorPicker"
import { Dropdown, DropdownButton } from "react-bootstrap"
import BubbleTag from "../common/BubbleTag"
import { documentsActions } from "../../actions/documentsActions"
import TagsFilterDropdown from "../common/TagsFilterDropdown"
import { getSortedListByDate, isDateValidated } from "../../utils"

const FiltersSearch = ({
	viewItemsBtn,
	setViewItemsBtn,
	elementsFilter,
	saveElementsFilter,
	filterList,
	setFilterList,
	createFilter,
	filtersButton,
	setFiltersButton,
	setRequestNewDateSearch,
	setFilterDate,
	filterDate,
	setNeedToFilter,
	savedTags,
	setSavedTags,
	savedTagsExclude,
	setSavedTagsExclude,
	applyFilterSource,
	updateFileTypes,
	setFileTypesRefresh,
	fileTypesRefresh,
	setDocCount,
	tagsList,
	setTagsList,
	setCurrentTag,
	setCurrentSort,
	currentSort,
}) => {
	/* ******************* TRANSLATIONS ******************* */
	const [t, i18n] = useTranslation("global")
	/* ******************* END TRANSLATIONS ******************* */

	/* ******************* REDUX STORE ******************* */
	//Redux actions
	// eslint-disable-next-line
	const dispatch = useDispatch()
	// eslint-disable-next-line
	const conceptDocs = useSelector((state) => state.buildconcept.concept_docs)
	const globalStateSearchDocumentList = useSelector((state) => state.search.searchResults)
	const sourceFilter = useSelector((state) => state.search.sourceFilter)
	const tagsApi = useSelector((state) => state.tags.custom_tags)
	const selectedBaseId = useSelector((state) => state.multiBase.selectedBase.project_id)
	const searchedDocsFiles = useSelector((state) => state.search.searchDocViewResults)
	/* ******************* END REDUX STORE ******************* */

	/* ******************* REACT STATES ******************* */
	// Data state
	const [searchDocumentsList, setSearchDocumentslist] = useState({ count: 0, data: [] })
	// Filetypes Filter
	const [showFiletypesFilter, setShowFiletypesFilter] = useState(false)
	// Create custom Tags (Color Picker)
	const [showColorPicker, setShowColorPicker] = useState(false)

	const [filetypesFilter, setFiletypesFilter] = useState({
		word: true,
		excel: true,
		powerpoint: true,
		pdf: true,
		textfile: true,
		email: true,
	})

	// Filters
	const [showFilters, setShowFilters] = useState(false)
	const [datepicker, setDatepicker] = useState({
		startDate: "",
		endDate: "",
		invalidMessage: "",
	})
	// Date Sort Filter
	const [dateSort, setDateSort] = useState("desc")
	// Tags input state
	const [tags, setTags] = useState(savedTags)
	// TagsExclude input state
	const [tagsExclude, setTagsExclude] = useState(savedTagsExclude)
	// Date Picker
	const [startDate, setStartDate] = useState(filtersButton.fromDate)
	const [endDate, setEndDate] = useState(filtersButton.toDate)
	const [numActiveFilters, setNumActiveFilter] = useState(6)
	/* ******************* END REACT STATES ******************* */

	/* ******************* USE-EFFECTS ******************* */

	useEffect(() => {
		resetDateFilters()
	}, [selectedBaseId])

	useEffect(() => {
		let activeFilters = 0
		Object.keys(filterList).map((key) => {
			if (filterList[key] === true) {
				activeFilters = activeFilters + 1
			}
		})
		setNumActiveFilter(activeFilters)
	}, [filterList])

	useEffect(() => {
		if (viewItemsBtn === "list") setSearchDocumentslist(globalStateSearchDocumentList)
		return
		// eslint-disable-next-line
	}, [globalStateSearchDocumentList])

	useEffect(() => {
		if (viewItemsBtn === "files") setSearchDocumentslist(searchedDocsFiles)
		return
	}, [searchedDocsFiles])

	useEffect(() => {
		setDocCount(searchDocumentsList.count)
		return
		// eslint-disable-next-line
	}, [searchDocumentsList])

	useEffect(() => {
		setFilterDate({
			start: filtersButton.fromDate,
			end: filtersButton.toDate,
		})

		let auxFromDate = filtersButton.fromDate === "" ? null : new Date(filtersButton.fromDate)
		let auxToDate = filtersButton.toDate === "" ? null : new Date(filtersButton.toDate)

		setDatepicker({
			startDate:
				auxFromDate === null
					? ""
					: `${auxFromDate.getFullYear()}-${("0" + (auxFromDate.getMonth() + 1)).slice(-2)}-${("0" + auxFromDate.getDate()).slice(
							-2
					  )}`,
			endDate:
				auxToDate === null
					? ""
					: `${auxToDate.getFullYear()}-${("0" + (auxToDate.getMonth() + 1)).slice(-2)}-${("0" + auxToDate.getDate()).slice(-2)}`,
		})
	}, [filtersButton.fromDate, filtersButton.toDate])

	useEffect(() => {
		saveElementsFilter({
			...elementsFilter,
			date: dateSort,
		})

		if (searchDocumentsList.data.length > 0) {
			let auxDocList = searchDocumentsList.data
			if (auxDocList.length > 0) {
				auxDocList.forEach(function (item, i) {
					if (item.hasOwnProperty("tagged_date") && item.tagged_date !== null && item.tagged_date !== undefined) {
					} else {
						item["tagged_date"] = item.creation_time
						auxDocList[i] = item
					}
				})
			}
			//     if (dateSort==="asc"){
			//         auxDocList.sort((a, b) => {
			//             let b_value=b.tagged_date;
			//             if (b_value===undefined){
			//               b_value=new Date(b.tagged_date).getTime();
			//             }
			//             let a_value=a.tagged_date;
			//             if (a_value===undefined){
			//               a_value=new Date(a.tagged_date).getTime();
			//             }
			//           return parseInt(a_value) - parseInt(b_value);
			// });
			//     }else{
			//         auxDocList.sort((a, b) => {
			//           let b_value=b.tagged_date;
			//           if (b_value===undefined){
			//             b_value=new Date(b.tagged_date).getTime();
			//           }
			//           let a_value=a.tagged_date;
			//           if (a_value===undefined){
			//             a_value=new Date(a.tagged_date).getTime();
			//           }
			//         return parseInt(b_value) - parseInt(a_value)
			// });
			//     }
			auxDocList = getSortedListByDate(auxDocList, dateSort)
			setSearchDocumentslist({
				...searchDocumentsList,
				data: auxDocList,
			})
		}
		return

		// eslint-disable-next-line
	}, [dateSort])

	useEffect(() => {
		setFiltersButton({
			...filtersButton,
			searchWord: [tags],
		})
		return
		// eslint-disable-next-line
	}, [tags])

	useEffect(() => {
		setFiltersButton({
			...filtersButton,
			searchWordExclude: [tagsExclude],
		})
		return
		// eslint-disable-next-line
	}, [tagsExclude])

	useEffect(() => {
		if (!showFilters) {
			checkDateFilterChanges()
		}
	}, [showFilters])

	useEffect(() => {
		setFiltersButton({
			...filtersButton,
			fromDate: startDate,
			toDate: endDate,
		})
	}, [startDate, endDate])
	/* ******************* END USE-EFFECTS ******************* */

	/* ******************* CUSTOM FUNCTIONS ******************* */
	// Filter by priority
	const mainTagClick = (tag_id) => {
		setCurrentTag(tag_id)
		saveElementsFilter({
			coloursFilter: tag_id,
		})
	}

	const updateFilters = (e) => {
		setFiltersButton({
			...filtersButton,
			[e.target.name]: !filtersButton[e.target.name],
		})
	}

	const updateDateFilters = (e) => {
		setDatepicker({
			...datepicker,
			invalidMessage: "",
			[e.target.name]: e.target.value,
		})
	}

	const applyDateFilter = (e) => {
		e.preventDefault()
		const date = {
			fromDate: datepicker.startDate === "" ? datepicker.startDate : new Date(datepicker.startDate),
			toDate: datepicker.endDate === "" ? datepicker.endDate : new Date(datepicker.endDate),
		}
		let invalidMessage = ""
		if ((date.fromDate === "" || isDateValidated(date.fromDate)) && (date.toDate === "" || isDateValidated(date.toDate))) {
			if (date.fromDate > date.toDate && date.toDate !== "") {
				invalidMessage = "*Atention! Start date can't be greater than End date"
			} else if (date.fromDate === "" && date.toDate === "") {
				invalidMessage = "Please enter a date!"
			} else {
				setFiltersButton({
					...filtersButton,
					fromDate: date.fromDate,
					toDate: date.toDate,
				})
				setShowFilters(false)
			}
		} else {
			invalidMessage = "Please enter a valid date!!"
		}
		setDatepicker({
			...datepicker,
			invalidMessage,
		})
	}

	const resetDateFilters = (e) => {
		if (e) e.preventDefault()

		setFiltersButton({
			...filtersButton,
			fromDate: "",
			toDate: "",
		})

		setDatepicker({
			startDate: "",
			endDate: "",
		})

		setStartDate("")
		setEndDate("")
	}

	const submitFiltersForm = (e) => {
		e.preventDefault()

		createFilter(filtersButton)
	}

	const requestRefreshContentFilterType = () => {}

	// OUTSIDE ALERTER
	/**
	 * Hook that alerts clicks outside of the passed ref
	 */
	const useOutsideAlerter = (ref) => {
		useEffect(() => {
			/**
			 * Alert if clicked on outside of element
			 */
			function handleClickOutside(event) {
				if (showFiletypesFilter === true) {
					requestRefreshContentFilterType()
				}
				if (showColorPicker === true) {
					requestRefreshContentFilterType()
				}
				if (ref.current && !ref.current.contains(event.target)) {
					//alert("You clicked outside of me!");
					setShowFilters(false)
					if (showFiletypesFilter === true) {
						requestRefreshContentFilterType()
					}
					setShowFiletypesFilter(false)
					if (showColorPicker === true) {
						requestRefreshContentFilterType()
					}
					setShowColorPicker(false)
				}
			}

			// Bind the event listener
			document.addEventListener("mousedown", handleClickOutside)
			return () => {
				// Unbind the event listener on clean up
				document.removeEventListener("mousedown", handleClickOutside)
			}
		}, [ref])
	}

	const checkDateFilterChanges = () => {
		if (filtersButton.fromDate !== "") {
			if (sourceFilter.fromDate === "") {
				//Last search includes everything in from, so there is no problem
			} else {
				if (new Date(filtersButton.fromDate) < new Date(sourceFilter.fromDate)) {
					//need to research
					setRequestNewDateSearch(true)
					return
				}
			}
		}
		if (filtersButton.toDate !== "") {
			if (sourceFilter.toDate === "") {
				//Last search includes everything in from, so there is no problem
			} else {
				if (new Date(filtersButton.toDate) > new Date(sourceFilter.toDate)) {
					//need to research
					setRequestNewDateSearch(true)
					return
				}
			}
		}

		if (sourceFilter.fromDate !== "" && filtersButton.fromDate === "") {
			setRequestNewDateSearch(true)
			return
		}

		if (sourceFilter.toDate !== "" && filtersButton.toDate === "") {
			setRequestNewDateSearch(true)
			return
		}
	}

	const updateCurrentTags = (newTags) => {
		setSavedTags(newTags)
	}

	const updateCurrentTagsExclude = (newTagsExclude) => {
		setSavedTagsExclude(newTagsExclude)
	}

	const updateFilterList = () => {
		//setFilterList({...filterList, "pdf": !filterList.pdf});
	}

	const refreshFiletypes = () => {
		setFileTypesRefresh(Math.random())
	}
	/* ******************* END CUSTOM FUNCTIONS ******************* */

	/* ******************* VARIABLES ******************* */
	const wrapperRef = useRef(null)
	useOutsideAlerter(wrapperRef)
	// DatePicker custom options
	const initial_date = window._env_.REACT_APP_INITIAL_DATE_FILTER
	const years = range(initial_date, getYear(new Date()) + 1, 1)
	const months = [
		"January",
		"February",
		"March",
		"April",
		"May",
		"June",
		"July",
		"August",
		"September",
		"October",
		"November",
		"December",
	]

	/* ******************* END VARIABLES ******************* */

	return (
		<Fragment>
			<div className="container-fluid">
				<div className="col-12 divFilters" ref={wrapperRef}>
					<div className="col-5 divBlockFilterElements">
						<div id="numDocs" className="col-6 divBlock">
							<span data-cy="numdocs">
								<strong>
									{viewItemsBtn === "list" ? (
										<>{globalStateSearchDocumentList?.count || 0}</>
									) : (
										<>{searchedDocsFiles?.count || 0}</>
									)}
								</strong>{" "}
								{t("search.filters_search_result")}
							</span>
						</div>
						<div id="filters" className="col-3 divBlock">
							<div id="block_info_search_1">
								<div className="divBlock">
									<a
										href="/#"
										onClick={(e) => {
											e.preventDefault()
											setShowFilters(!showFilters)
											if (showFiletypesFilter === true) {
												requestRefreshContentFilterType()
											}
											setShowFiletypesFilter(false)
										}}
										data-cy="filters"
									>
										{t("search.filters_highlights_title")}
									</a>
								</div>
								<div className="divBlock infoFiltersSearch">
									<InfoDialog btninfo="infoFiltersSearch" className="infoFiltersSearch" />
								</div>
							</div>
							<div className={showFilters ? "show divFiletypes mt-20" : "hide"}>
								<div className="col-3">
									<div className="col-12 d-flex mb-3">
										<form className="col-12 divBlock" onSubmit={submitFiltersForm}>
											<div className="col-12 divBlock">
												<h5>{t("search.filters_highlights")}</h5>
											</div>
											<div className="col-12 divBlock form-switch mt-10">
												<div className="col-6 divBlock">
													<label className="form-check-label">{t("search.filters_highlights_dates")}</label>
												</div>
												<div className="col-6 divBlock pl-3">
													<input
														name="dates"
														className="form-check-input"
														type="checkbox"
														id="flexSwitchCheckChecked_date"
														defaultChecked={filtersButton.dates}
														onChange={updateFilters}
													/>
												</div>
											</div>
											<div className="col-12 divBlock form-switch mt-10">
												<div className="col-6 divBlock">
													<label className="form-check-label">{t("search.filters_highlights_concepts")}</label>
												</div>
												<div className="col-6 divBlock pl-3">
													<input
														name="concepts"
														className="form-check-input"
														type="checkbox"
														id="flexSwitchCheckChecked_concept"
														defaultChecked={filtersButton.concepts}
														onChange={updateFilters}
													/>
												</div>
											</div>
											<div className="col-12 divBlock form-switch mt-10">
												<div className="col-6 divBlock">
													<label className="form-check-label">{t("search.filters_highlights_emails")}</label>
												</div>
												<div className="col-6 divBlock pl-3">
													<input
														name="emails"
														className="form-check-input"
														type="checkbox"
														id="flexSwitchCheckChecked_email"
														defaultChecked={filtersButton.emails}
														onChange={updateFilters}
													/>
												</div>
											</div>
											<div className="col-12 divBlock form-switch mt-10">
												<div className="col-6 divBlock">
													<label className="form-check-label">
														{t("search.filters_highlights_specific_word")}
													</label>
												</div>
												<div className="col-6 divBlock pl-3">
													<input
														name="specificWord"
														className="form-check-input"
														type="checkbox"
														id="flexSwitchCheckChecked_word"
														defaultChecked={filtersButton.specificWord}
														onChange={updateFilters}
													/>
												</div>
											</div>
											<div className="col-12 divBlock form-control mt-10">
												<div data-cy="specific_word" className="col-12 divBlock pl-3">
													<ReactTagInput
														tags={tags}
														placeholder={t("search.filters_highlights_enter")}
														maxTags={10}
														editable={true}
														readOnly={false}
														removeOnBackspace={true}
														onChange={(newTags) => {
															if (newTags !== "") {
																updateCurrentTags(newTags)
															}
															setTags(newTags)
														}}
													/>
												</div>
												<div className="col-12 divBlock">
													<small>{t("search.filters_highlights_remember")}</small>
												</div>
											</div>
											<div className="col-12 divBlock form-switch mt-10" style={{ display: "none" }}>
												<div className="col-6 divBlock">
													<label className="form-check-label">{t("search.filters_highlights_remove")}</label>
												</div>
												<div className="col-6 divBlock pl-3">
													<input
														name="specificWordExclude"
														className="form-check-input"
														type="checkbox"
														id="flexSwitchCheckChecked_word"
														onChange={updateFilters}
													/>
												</div>
											</div>
											<div className="col-12 divBlock form-control mt-10" style={{ display: "none" }}>
												<div className="col-12 divBlock pl-3">
													<ReactTagInput
														tags={tagsExclude}
														placeholder="Type and press enter"
														maxTags={10}
														editable={true}
														readOnly={false}
														removeOnBackspace={true}
														//onChange={(newTagsExclude) => setTagsExclude(newTagsExclude)}
														onChange={(newTagsExclude) => {
															if (newTagsExclude !== "") {
																updateCurrentTagsExclude(newTagsExclude)
															}
															setTagsExclude(newTagsExclude)
														}}
													/>
												</div>
												<div className="col-12 divBlock">
													<small>*Remember to press enter after type a word</small>
												</div>
											</div>

											<div className="col-12 divBlock mt-5">
												<h5>{t("search.filters_search_dates")}</h5>
											</div>
											{/* <div className="col-10 divBlock">
                                                <CustomDatePicker/>
                                            </div> */}
											<div className="col-12 divBlock mt-10">
												<div className="col-2 divBlock">
													<label className="form-label">{t("search.filters_highlights_from")}</label>
												</div>

												<div data-cy="from_date" className="col-2 divBlock">
													{/* ************* DATEPICKER ************* */}
													{/* <DatePicker
                                                        dateFormat="dd/MM/yyyy"
                                                        renderCustomHeader={({
                                                            date,
                                                            changeYear,
                                                            changeMonth,
                                                            decreaseMonth,
                                                            increaseMonth,
                                                            prevMonthButtonDisabled,
                                                            nextMonthButtonDisabled,
                                                          }) => (
                                                            <div
                                                              style={{
                                                                margin: 10,
                                                                display: "flex",
                                                                justifyContent: "center",
                                                              }}
                                                            >
                                                              <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                                {"<"}
                                                              </button>
                                                              <select
                                                                style={{
                                                                    width: '50px',
                                                                    paddingLeft: '4px',
                                                                }}
                                                                value={getYear(date)}
                                                                onChange={({ target: { value } }) => changeYear(value)}
                                                              >
                                                                {years.map((option) => (
                                                                  <option key={option} value={option}>
                                                                    {option}
                                                                  </option>
                                                                ))}
                                                              </select>
                                                    
                                                              <select
                                                                style={{
                                                                    width: '80px',
                                                                    paddingLeft: '6px',
                                                                }}
                                                                value={months[getMonth(date)]}
                                                                onChange={({ target: { value } }) =>
                                                                  changeMonth(months.indexOf(value))
                                                                }
                                                              >
                                                                {months.map((option) => (
                                                                  <option key={option} value={option}>
                                                                    {option}
                                                                  </option>
                                                                ))}
                                                              </select>
                                                    
                                                              <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                                                {">"}
                                                              </button>
                                                            </div>
                                                          )}
                                                           
                                                        selected={filtersButton.fromDate} 
                                                        //onChange={(date) => setStartDate(date)}
                                                        onChange={(date)=>{
                                                            setStartDate(date);
                                                            //updateDateFilters();
                                                        }}
                                                        //isClearable={true}
                                                    /> */}
													{/* ************* END DATEPICKER ************* */}
													<input
														name="startDate"
														className="form-input"
														type="date"
														id="datePickerFrom"
														onChange={updateDateFilters}
														value={datepicker.startDate}
													/>
												</div>
											</div>
											<div className="col-12 divBlock mt-10">
												<div className="col-2 divBlock">
													<label className="form-label">{t("search.filters_highlights_to")}</label>
												</div>
												<div data-cy="to_date" className="col-2 divBlock">
													{/* ************* DATEPICKER ************* */}
													{/* <DatePicker
                                                        dateFormat="dd/MM/yyyy"
                                                        renderCustomHeader={({
                                                            date,
                                                            changeYear,
                                                            changeMonth,
                                                            decreaseMonth,
                                                            increaseMonth,
                                                            prevMonthButtonDisabled,
                                                            nextMonthButtonDisabled,
                                                          }) => (
                                                            <div
                                                              style={{
                                                                margin: 10,
                                                                display: "flex",
                                                                justifyContent: "center",
                                                              }}
                                                            >
                                                              <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                                                                {"<"}
                                                              </button>
                                                              <select
                                                                style={{
                                                                    width: '50px',
                                                                    paddingLeft: '4px',
                                                                }}
                                                                value={getYear(date)}
                                                                onChange={({ target: { value } }) => changeYear(value)}
                                                              >
                                                                {years.map((option) => (
                                                                  <option key={option} value={option}>
                                                                    {option}
                                                                  </option>
                                                                ))}
                                                              </select>
                                                    
                                                              <select
                                                                style={{
                                                                    width: '80px',
                                                                    paddingLeft: '6px',
                                                                }}
                                                                value={months[getMonth(date)]}
                                                                onChange={({ target: { value } }) =>
                                                                  changeMonth(months.indexOf(value))
                                                                }
                                                              >
                                                                {months.map((option) => (
                                                                  <option key={option} value={option}>
                                                                    {option}
                                                                  </option>
                                                                ))}
                                                              </select>
                                                    
                                                              <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                                                                {">"}
                                                              </button>
                                                            </div>
                                                          )} 
                                                        selected={filtersButton.toDate} 
                                                        //onChange={(date) => setEndDate(date)} 
                                                        onChange={(date)=>{
                                                            setEndDate(date);
                                                            //updateDateFilters();
                                                        }}
                                                        //isClearable={true}
                                                    /> */}
													{/* ************* END DATEPICKER ************* */}
													<input
														name="endDate"
														className="form-input"
														type="date"
														id="datePickerTo"
														onChange={updateDateFilters}
														value={datepicker.endDate}
													/>
												</div>
											</div>
											{!!datepicker.invalidMessage ? (
												<div className="col-12 divBlock mt-4 d-flex justify-content-center">
													<small style={{ color: "red" }}>{datepicker.invalidMessage}</small>
												</div>
											) : null}
											<div className="col-12 divBlock mt-4 d-flex justify-content-center">
												<div className="col-6 divBlock d-flex justify-content-center">
													<a href="/#" onClick={applyDateFilter} data-cy="apply_dates">
														Apply dates
													</a>
												</div>
												<div className="col-6 divBlock d-flex justify-content-center">
													<a href="/#" onClick={resetDateFilters} data-cy="reset_dates">
														{t("search.filters_highlights_reset")}
													</a>
												</div>
												<div className="col-6 divBlock hide">
													<button
														type="submit"
														className="btn btn-sm btn-outline-primary"
														style={{ float: "right" }}
													>
														Apply
													</button>
												</div>
											</div>
											<div className="col-12 divBlock mt-4 d-flex justify-content-center  hidden-important">
												<div className="col-6 divBlock d-flex justify-content-center">
													<button
														className="btn btn-sm btn-outline-primary"
														onClick={(e) => {
															e.preventDefault()
															setShowFilters(!showFilters)
															//checkDateFilterChanges();
														}}
													>
														Apply
													</button>
												</div>
												<div className="col-6 divBlock hide">
													<button
														type="submit"
														className="btn btn-sm btn-outline-primary"
														style={{ float: "right" }}
													>
														Apply
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
						<div className="col-3 divBlock">
							<a
								id="fileTypes"
								href="/#"
								onClick={(e) => {
									e.preventDefault()
									if (showFiletypesFilter === true) {
										requestRefreshContentFilterType()
									}
									setShowFiletypesFilter(!showFiletypesFilter)
									setShowFilters(false)
									refreshFiletypes()
								}}
							>
								{t("search.filters_file_types")} ({numActiveFilters}/{Object.keys(filterList).length})
							</a>

							<div className={showFiletypesFilter ? "show divFiletypes" : "hide"}>
								<div className="col-3">
									<div className="col-12">
										<h5>{t("search.filters_file_types")}</h5>
									</div>
									<div className="col-12 d-flex mb-3">
										<form key={fileTypesRefresh} className="col-12 divBlock">
											{Object.keys(filterList).map((key) => (
												<div className="col-12 divBlock form-switch mt-10" key={key}>
													<div className="col-8 divBlock">
														<label className="form-check-label">
															{sourceHelper.getHumanValue(key)}
															{/* {key.split('_').reduce((a, b) => a.charAt(0).toUpperCase() + a.slice(1) + ' ' + b.charAt(0).toUpperCase() + b.slice(1))} */}
														</label>
													</div>
													<div className="col-4 divBlock pl-3">
														<input
															key={key + "_input_" + fileTypesRefresh}
															className="form-check-input sourceFilterCheck"
															id={"input_" + key}
															type="checkbox"
															defaultChecked={filterList[key]}
															onChange={(e) => {
																setFilterList({ ...filterList, [key]: !filterList[key] })
															}}
															data-value={filterList[key]}
														/>
													</div>
												</div>
											))}
											<div className="col-12 divBlock mt-4 d-flex justify-content-center">
												<div className="col-6 divBlock d-flex justify-content-center">
													<button
														data-cy="apply_button"
														type="submit"
														className="btn btn-sm btn-outline-primary"
														onClick={(e) => {
															e.preventDefault()
															applyFilterSource()
															setShowFiletypesFilter(false)
														}}
													>
														{t("search.filters_all_files_apply")}
													</button>
												</div>
											</div>
										</form>
									</div>
								</div>
							</div>
						</div>
					</div>

					<div id="date" className="col-1 divBlock">
						<div className="col-12 divBlock min-100">
							<div className="col-4 divBlock mt-1">
								<span>
									<strong>{t("search.filters_date")}</strong>
								</span>
							</div>
							<div className="col-2 divBlock btnArrow mt-1">
								{viewItemsBtn === "list" ? (
									<>
										<i
											data-cy="date_sort_down"
											className={
												dateSort === "asc"
													? "bi bi-arrow-down-circle dateIcon"
													: "bi bi-arrow-down-circle-fill dateIcon"
											}
											style={{ cursor: "pointer" }}
											onClick={(e) => {
												setDateSort("desc")
											}}
										></i>
									</>
								) : (
									<>
										<i
											data-cy="date_sort_down"
											className={
												currentSort === "desc"
													? "bi bi-arrow-down-circle-fill dateIcon"
													: "bi bi-arrow-down-circle dateIcon"
											}
											style={{ cursor: "pointer" }}
											onClick={(e) => {
												setCurrentSort("desc")
											}}
										></i>
									</>
								)}
							</div>
							<div className="col-2 divBlock btnArrow mt-1">
								{viewItemsBtn === "list" ? (
									<>
										<i
											data-cy="date_sort_up"
											className={
												dateSort === "asc"
													? "bi bi-arrow-up-circle-fill dateIcon ml-2"
													: "bi bi-arrow-up-circle dateIcon ml-2"
											}
											style={{ cursor: "pointer" }}
											onClick={(e) => {
												setDateSort("asc")
											}}
										></i>
									</>
								) : (
									<>
										<i
											data-cy="date_sort_up"
											className={
												currentSort === "asc"
													? "bi bi-arrow-up-circle-fill dateIcon ml-2"
													: "bi bi-arrow-up-circle dateIcon ml-2"
											}
											style={{ cursor: "pointer" }}
											onClick={(e) => {
												setCurrentSort("asc")
											}}
										></i>
									</>
								)}
							</div>
						</div>
					</div>

					<div className="col-5 divBlock">
						<div className="col-12 divBlock d-flex justify-content-center filterPrioritySearch">
							{/* <div id="createCustomTags" className="col-2 divBlock mt-1">
								<a
									id="customTagsBtn"
									data-cy="create_custom_tags_btn"
									href="/#"
									onClick={(e) => {
										e.preventDefault()
										if (showColorPicker === true) {
											requestRefreshContentFilterType()
										}
										setShowColorPicker(!showColorPicker)
										setShowFilters(false)
									}}
								>
									Create tags
								</a>
							</div> */}
							{/* <div className={showColorPicker ? "show divCreateCustomTags" : "hide"}>
								<div className="col-3">
									<div className="col-12">
										<h5>Create custom tags</h5>
									</div>
									<div className="col-12 mb-3">
										<ColorPicker />
									</div>
								</div>
							</div>
							<BubbleTag elementsFilter={elementsFilter} mainTagClick={mainTagClick} /> */}
							{/* <div className="col-1 divBlock btnColor divColor">
                                <Tooltip title={t("search.tooltip_undecided")} placement="bottom" arrow>
                                    <button
                                        data-cy="yellow_btn"
                                        className= {elementsFilter === 'yellow' ? "btn btn-warning  btnRefreshTermsList rounded-pill ml-2 btnColorFilter" : "btn btn-outline-warning  btnRefreshTermsList rounded-pill ml-2 btnColorFilter"} 
                                        style={{padding: '4px'}}
                                        onClick={yellowBtnClick}
                                    >
                                        Y
                                    </button>
                                </Tooltip>
                            </div> */}
							{/* <div className="col-1 divBlock btnColor divColor">
                                <Tooltip title={t("search.tooltip_not_important")} placement="bottom" arrow>
                                    <button
                                        data-cy="green_btn"
                                        className= {elementsFilter === 'green' ? "btn btn-success  btnRefreshTermsList rounded-pill ml-2 btnColorFilter" : "btn btn-outline-success  btnRefreshTermsList rounded-pill ml-2 btnColorFilter"} 
                                        style={{padding: '4px'}}
                                        onClick={greenBtnClick}
                                    >
                                        G
                                    </button>
                                </Tooltip>
                            </div> */}

							{/* <div id="selectCustomTags" className="col-2 divBlock mt-1">
								<TagsFilterDropdown tagsApi={tagsApi} mainTagClick={mainTagClick} />
							</div>

							<div className="col-1 divBlock infoFiltersSearchPriority">
								<InfoDialog btninfo="infoFiltersPrioritySearch" className="infoFiltersSearchPriority" />
							</div> */}
						</div>
					</div>
					{/* <div className="col-1 divBlock divButtonsViewSearch">
						<ListButton viewItemsBtn={viewItemsBtn} setViewItemsBtn={setViewItemsBtn} setNeedToFilter={setNeedToFilter} />
						<FilesButton viewItemsBtn={viewItemsBtn} setViewItemsBtn={setViewItemsBtn} setNeedToFilter={setNeedToFilter} />
					</div> */}
				</div>
			</div>
		</Fragment>
	)
}

export default FiltersSearch
